import React, { useState } from 'react';
import { Paper, Typography, Menu, MenuItem, IconButton, useTheme, Box, Button } from '@mui/material';
import kebabMenu from 'packages/novous_web/src/assets/icons/Kebab Menu.svg';
import { Link, useNavigate } from 'react-router-dom';
import { MoreVert, Visibility } from '@mui/icons-material';

interface ReportCardProps {
  imgSrc?: string;
  heading: string;
  overlineText: string;
  dateTime?: string;
  menuItems?: { name: string; action: () => void; icon?: any, navigateTo?: string; }[];
  navigateTo: string;
  viewButton?: {
    icon?: React.ReactNode;
    navigateTo: string;
  };
}

const ReportCard: React.FC<ReportCardProps> = ({ imgSrc, heading, overlineText, dateTime, menuItems, navigateTo, viewButton }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (item: { action?: () => void; navigateTo?: string }) => {
    if (item.navigateTo) {
      navigate(item.navigateTo);
    } else if (item.action) {
      item.action();
    }
    handleClose();
  };

  const handleViewButtonClick = () => {
    if (viewButton?.navigateTo) {
      navigate(viewButton.navigateTo);
    }
  };

  return (
    <Paper className='flex p-4 gap-2 w-auto rounded-lg border justify-between items-start h-full' sx={{ borderRadius: '8px', cursor: 'pointer' }}>
      <Link className='flex w-full justify-between items-start gap-2' to={navigateTo} style={{ textDecoration: 'none' }}>
        {imgSrc && <img src={imgSrc} width={32} height={32} alt='icon' style={{ background: theme.palette.selected }} className='p-1 rounded-lg' />}
        <div className='flex w-full justify-start flex-col gap-1'>
          <Typography variant='button' fontSize={16} fontWeight={600}>{heading}</Typography>
          <Typography variant='overline' color='secondary' fontSize={16} fontWeight={400}>{overlineText}</Typography>
        </div>
      </Link>
      {menuItems &&
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            size="small"
            onClick={handleClick}
            sx={{ p: 1 }}
          >
            <MoreVert fontSize="small" />
          </IconButton>
        </Box>
      }
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems && menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleMenuItemClick(item)}
            className={`gap-3 items-center ${index !== menuItems.length - 1 ? 'mb-4' : ''}`}
          >
            {item.icon && item.icon}
            {item.name}
          </MenuItem>
        ))}
      </Menu>

      <Box sx={{ display: 'flex', gap: 1 }}>
        {viewButton && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleViewButtonClick}
            endIcon={viewButton.icon || <Visibility fontSize="small" />}
            sx={{ 
              textTransform: 'none',
              minWidth: 'auto',
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            View
          </Button>
        )}
      </Box>
      
    </Paper>
  );
};

export default ReportCard;